export default {
    MANUAL: 1,
    REQUISICAO: 2,
    INVENTARIO: 3,
    ESTORNO: 4,
    DISPENSACAO_FARMACIA: 5,
    BAIXA: 6,
    TRANSFERENCIA: 7,
    DISPENSACAO_AMBULATORIO: 9,
}